module.exports = __webpack_public_path__ + "static/couple-on-patio-mobile.e2a6bfb7.webp";